/**
 * Shared recharts chrome.
 *
 * Every chart previously repeated its own grid stroke, tick size and axis
 * settings, so no two charts in the dashboard quite matched. Spreading these
 * onto the recharts elements keeps them in step, and routes the colours through
 * the dashboard tokens so a chart follows its app's accent.
 *
 * Series colours are read at render time rather than hard-coded, because the
 * co-owner accent is applied by a CSS variable on the shell.
 */

export const CHART_GRID = {
  strokeDasharray: '3 3',
  vertical: false,
  stroke: 'var(--dashboard-chart-grid)',
} as const

export const CHART_AXIS = {
  tick: { fontSize: 11, fill: 'var(--dashboard-text-axis)' },
  axisLine: false,
  tickLine: false,
} as const

export const CHART_CURSOR = {
  stroke: 'var(--dashboard-chart-cursor)',
  strokeDasharray: '4 4',
} as const

/** Primary and secondary series colours; both follow the active accent. */
export const CHART_SERIES = ['var(--dashboard-chart-1)', 'var(--dashboard-chart-2)'] as const

/** Minimum plot height. Below this a line chart reads as a sparkline. */
export const CHART_MIN_HEIGHT = 'min-h-[16rem]'
